import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { blue, green, orange, pink, red } from '@material-ui/core/colors';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    header: {
      padding: `${theme.spacing(1.75)}px ${theme.spacing(3)}px`,
    },
    title: {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
      marginTop: theme.spacing(6),
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    logo: {
      margin: theme.spacing(2),
    },
    infoContainer: {
      disply: 'flex',
      marginBottom: theme.spacing(1),
      height: '25%',
    },
    infoBar: {
      width: '30%',
      height: '100%',
    },
    margin: {
      margin: theme.spacing(1),
    },
    applyButton: {
      width: 142,
      borderRadius: '0 4px 4px 0',
      height: 50,
      color: theme.palette.background.paper,
      fontSize: 14,
      textTransform: 'none',
      boxShadow: 'none',
      marginRight: theme.spacing(1),
      backgroundColor: green[500],
      '&:hover': {
        backgroundColor: green[700],
      },
    },
    select: {
      margin: theme.spacing(1),
      //width: '30%',
    },
    link: {
      color: 'blue',
    },
    addNewButton: {
      height: 50,
      fontSize: 14,
      marginLeft: 10,
      textTransform: 'none',
      boxShadow: 'none',
      //margin: theme.spacing(1),
      color: theme.palette.getContrastText(blue[500]),
      backgroundColor: '#5081FF',
      '&:hover': {
        backgroundColor: blue[700],
      },
    },
    box: {
      marginBottom: theme.spacing(3),
    },
    headerBtn: {
      boxShadow: 'none',
      textTransform: 'none',
      lineHeight: '36px',
      padding: `0 ${theme.spacing(3)}px`,
      height: 50,
    },
    noBorder: {
      border: 'none',
    },
    dataGrid: {
      width: '100%',
      '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
      '& .MuiDataGrid-root .MuiDataGrid-row': {
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .row-background-error': {
        backgroundColor: red[50],
        '&:hover': {
          backgroundColor: red[100],
        },
      },
      '& .row-background-alert': {
        backgroundColor: pink[50],
        '&:hover': {
          backgroundColor: pink[100],
        },
      },
      '& .row-background-transaction': {
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: 'rgba(255, 80, 95, 0.04)',
        },
      },
      '& .cell-text-color-error': {
        color: pink[700],
      },
      '& .cell-text-color-alert': {
        color: orange[700],
      },
      '& .cell-text-color-transaction': {
        color: 'black',
        fontWeight: '500',
        textTransform: 'capitalize',
      },
      '& .MuiDataGrid-colCellTitle': {
        color: 'black',
        fontWeight: '700',
        textTransform: 'capitalize',
      },
    },
    tooltip: {
      width: '50px',
      height: '25px',
      fontSize: '10px',
      lineHeight: 'auto',
    },
  }),
  {
    index: 1,
  }
);

export const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
    },
    input: {
      width: theme.spacing(20),
      borderRadius: '4px 0 0 4px',
      position: 'relative',
      background: theme.palette.action.hover,
      fontSize: 14,
      padding: 16,
    },
  })
)(InputBase);
